import React, { useEffect, useState } from 'react';

const stripHtml = (html) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

const PrintOrders = () => {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const savedOrders = localStorage.getItem("ordersToPrint");
    if (savedOrders) {
      setOrders(JSON.parse(savedOrders));
      setTimeout(() => {
        window.print();
        localStorage.removeItem("ordersToPrint");
      }, 500);
    }
  }, []);

  return (
    <div className="p-4 print-table">
      <h1 className="text-xl font-bold mb-4">Orders Summary</h1>
      <table className="w-full text-xs border border-black" style={{ borderCollapse: 'collapse' }}>
        <thead className="bg-gray-200">
          <tr>
            <th className="border border-black px-2 py-1">Order Number</th>
            <th className="border border-black px-2 py-1">Product ID</th>
            <th className="border border-black px-2 py-1">Date</th>
            <th className="border border-black px-2 py-1">Model Name</th>
            <th className="border border-black px-2 py-1">Product Type</th>
            <th className="border border-black px-2 py-1">Custom Name</th>
            <th className="border border-black px-2 py-1">Dealt Weight</th>
            <th className="border border-black px-2 py-1">Notes</th>
            <th className="border border-black px-2 py-1">Days Left</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((row, index) => {
  const product = row.product;
  const today = new Date();
  const deadline = new Date(row.Dtime);
  const diffTime = deadline - today;
  const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return (
    <tr key={index} className={row._multi ? 'bg-yellow-100' : ''}>
      <td className="border border-black px-2 py-1 text-center">
        {row._firstProduct ? row.orderId : ''}
      </td>
      <td className="border border-black px-2 py-1 text-center">{product.productId || '—'}</td>
      <td className="border border-black px-2 py-1 text-center">{new Date(row.orderDate).toLocaleDateString()}</td>
      <td className="border border-black px-2 py-1 text-center">{product.modelName || '—'}</td>
      <td className="border border-black px-2 py-1 text-center capitalize">{product.productType || '—'}</td>
      <td className="border border-black px-2 py-1 text-center">{product.customName || '—'}</td>
      <td className="border border-black px-2 py-1 text-center">{product.dealtWeight || '—'}</td>
      <td className="border border-black px-2 py-1">{stripHtml(product.notes || '—')}</td>
      <td className="border border-black px-2 py-1 text-center">
        {isNaN(daysLeft) ? '—' : `${daysLeft} day(s)`}
      </td>
    </tr>
  );
})}

        </tbody>
      </table>
    </div>
  );
};

export default PrintOrders;

